export default __webpack_public_path__ + "static/media/main.acc154b8.jpg";